import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Card } from '../ui/card';
import { Skeleton } from '../ui/skeleton';

interface ActionCardProps {
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
  label: string;
  value: number | undefined;
  description: string;
  to: string;
  search?: Record<string, unknown>;
  loading?: boolean;
}

export function ActionCard({
  icon,
  iconBg,
  iconColor,
  label,
  value,
  description,
  to,
  search,
  loading,
}: ActionCardProps) {
  return (
    <Card className="p-0 hover:shadow-md transition-all overflow-hidden">
      <Link
        to={to}
        search={search}
        activeProps={{}}
        className="group flex h-full items-center gap-4 rounded-2xl p-4 transition-colors"
      >
        <div
          className={cn('flex h-11 w-11 shrink-0 items-center justify-center rounded-xl', iconBg)}
        >
          <span className={iconColor}>{icon}</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-2">
            {loading ? (
              <Skeleton className="h-6 w-8" />
            ) : (
              <span className="text-2xl font-bold text-gray-900">{value ?? 0}</span>
            )}
            <span className="text-sm font-semibold text-gray-700">{label}</span>
          </div>
          <p className="text-xs text-gray-400 mt-0.5">{description}</p>
        </div>
        <ArrowRight
          size={16}
          className="shrink-0 text-gray-300 group-hover:text-brand-500 group-hover:translate-x-0.5 transition-all"
        />
      </Link>
    </Card>
  );
}
